// attachments/AttachmentProvider.jsx
import { createContext, useContext, useRef } from 'react';
import { useAttachment } from './useAttachment';

const AttachmentContext = createContext(null);

export const AttachmentProvider = ({ context, onUploaded, children }) => {
  const fileInputRef = useRef(null);
  const { uploadAttachment } = useAttachment(context);

  const openFilePicker = () => fileInputRef.current?.click();

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    await uploadAttachment(files);
    onUploaded?.(); // 🔁 refresh attachments
    e.target.value = '';
  };

  return (
    <AttachmentContext.Provider value={{ openFilePicker }}>
      <input
        type="file"
        hidden
        ref={fileInputRef}
        multiple
        onChange={handleFileChange}
      />
      {children}
    </AttachmentContext.Provider>
  );
};

export const useAttachmentContext = () => useContext(AttachmentContext);